import angular from 'angular';
import contactsModule from '../contactsModule';

function contactsService(apiParamsInitialization, httpService) {
  'ngInject';

  let contactsMetadata = {};
  return {
    getContactsMetaData() {
      const params = {};
      return httpService
        .httpGet(apiParamsInitialization.apiSets.getContactsMetadata, params)
        .then(data => (contactsMetadata = data));
    },

    getUserContacts(userIds, friendsDict) {
      const contactsMultiGetLimit = contactsMetadata.multiGetContactsMaxSize;
      const contactsUrlConfig = apiParamsInitialization.apiSets.multiGetContacts;
      return httpService
        .buildBatchPromises(
          contactsUrlConfig,
          userIds,
          contactsMultiGetLimit,
          'targetUserIds',
          'POST'
        )
        .then(function (data) {
          if (data && data.length > 0) {
            let contacts = [];
            contacts = [...contacts, ...data[0]];
            contacts.forEach(function (contact) {
              const userId = contact.targetUserId;
              if (!friendsDict[userId]) {
                friendsDict[userId] = {};
              }
              friendsDict[userId].contact = contact.targetUserTag;
            });
          }
        });
    }
  };
}

contactsModule.factory('contactsService', contactsService);

export default contactsService;
